// extracted by mini-css-extract-plugin
export default {"connectionsGraph":"ConnectionsGraph_connectionsGraph__L66Lt","centerX":"ConnectionsGraph_centerX__nsCDb"};